import moment from 'moment'
export default {
  getAlertasList(state) {
    var res = [];
    state.alertasArray.forEach(al => {
      let historial = al.historial ? al.historial.sort((a, b) => b.fecha - a.fecha) : []
      let aux = {
        tipo: (al.tipo) ? al.tipo : al.msj,
        prioridad: (al.prioridad) ? al.prioridad : 3,
        fecha: moment(al.fecha.toDate()).format('HH:mm YYYY-MM-DD'),
        historial: historial,
        lastFecha: historial.length > 0 ? moment.unix(historial[0].fecha).format('HH:mm') : moment(al.fecha.toDate()).format('HH:mm YYYY-MM-DD'),
        lastFechaUnix: historial.length > 0 ? historial[0].fecha : 0,
        lastMensaje: historial.length > 0 ? historial[0].mensaje : 'sin más info',
        id: al.id
      }
      res.push(aux);
    });
    return res;
  },
  getAlertasCount(state) {
    return state.alertasArray.filter(a => a.prioridad == 1 || a.prioridad == 2).length.toString();
  }
}